/**
 * frontend/src/components/ScoutBadge.jsx
 * SoundDAO Sprint 5A M6 — Inline scout badge icons next to player names.
 *
 * Props:
 *   badges — array of { badge_tier, creator_name, awarded_at }
 */

import React, { useState } from 'react';

const BADGE_ICON = {
  first_scout: '🥇',
  early_scout: '🥈',
  scout:       '🥉',
};

function formatDate(dateStr) {
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return '';
  }
}

export default function ScoutBadge({ badges }) {
  const [expanded, setExpanded] = useState(false);

  if (!badges || badges.length === 0) return null;

  // Filter out scout_basic (no icon)
  const displayable = badges.filter(b => BADGE_ICON[b.badge_tier]);
  if (displayable.length === 0) return null;

  const visible = expanded ? displayable : displayable.slice(0, 3);
  const remaining = displayable.length - 3;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', marginLeft: '4px' }}>
      {visible.map((badge, i) => (
        <span
          key={i}
          title={`${badge.creator_name || 'Unknown'} — ${formatDate(badge.awarded_at)}`}
          style={{ cursor: 'default', fontSize: '0.85rem' }}
        >
          {BADGE_ICON[badge.badge_tier]}
        </span>
      ))}
      {!expanded && remaining > 0 && (
        <button
          onClick={(e) => { e.stopPropagation(); setExpanded(true); }}
          style={{
            background: 'rgba(255,255,255,0.1)', border: 'none', color: 'rgba(255,255,255,0.6)',
            fontSize: '0.7rem', borderRadius: '8px', padding: '1px 5px', cursor: 'pointer',
            marginLeft: '2px',
          }}
        >
          +{remaining} more
        </button>
      )}
    </span>
  );
}
